import { defineComponent as _defineComponent } from 'vue'
import BCXAvatar from '@/components/molecules/BCXAvatar.vue';
import { computed, PropType } from 'vue';
import { ProjectOfferResponse } from '@/models/MyProjects';
import useUser from '@/mixins/useUser';
import useFormattedDateTime from '@/mixins/useFormattedDateTime';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectOffersListItem',
  props: {
  offer: {
    type: Object as PropType<ProjectOfferResponse>,
    required: true
  }
},
  setup(__props) {

const props = __props;



const creator = computed(() => props.offer.creator);

const { getFormattedDate } = useFormattedDateTime();

const { displayName } = useUser(creator);

const date = computed(() => getFormattedDate(props.offer.created));


return { __sfc: true,props, creator, getFormattedDate, displayName, date, BCXAvatar }
}

})